// extracted by mini-css-extract-plugin
export var auto = "_3n-1";
export var spinner = "_3n-0";